import { Box, Typography, useTheme } from "@mui/material";
import { useTranslation } from 'react-i18next';
import TitleCase from "components/formatting/TitleCase";
import { AreaChart, Area, ResponsiveContainer } from 'recharts';

interface PercentChangeTooltipProps {
  dataSeries: any;
  color: string;
}

export default function PercentChangeTooltip(props: PercentChangeTooltipProps): JSX.Element {
  const theme = useTheme();
  const { i18n } = useTranslation();
  const { dataSeries, color }: PercentChangeTooltipProps = props;

  const formattedData = dataSeries.values.map((value: number, index: number) => {
    return {
      index: index,
      value: value
    };
  });

  return (
    <Box sx={{ minWidth: "100px" }}>
      {/* Title */}
      <Typography variant="h4">
        <TitleCase text={dataSeries.field_label}/>
      </Typography>

      {/* Sparkline */}
      <ResponsiveContainer width="100%" height={50}>
        <AreaChart data={formattedData}>
          <Area type="monotone" dataKey="value" stroke={color} fill={color} />
        </AreaChart>
      </ResponsiveContainer>
    </Box>
  );
} 
